import { useMemo } from "react";

export const useTV = () => {
  const isTv = useMemo(() => {
    // Check for device query param with value 'tv'
    const urlParams = new URLSearchParams(window.location.search);
    const deviceParam = urlParams.get("device");
    
    // Check both hostname and query parameter
    return deviceParam === "tv";
  }, []);

  return { isTv };
};
